import type { FinancialRecurrence } from '../../lib/api.js';

const monthName = (competence: string) =>
  new Date(`${competence.slice(0, 7)}-01T12:00:00Z`).toLocaleDateString('pt-BR', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });

const capitalized = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

/// O aviso do cadastro e da reativação diz o que já entrou em Despesas e o que espera revisão.
export function generationNotice(
  base: string,
  generation: FinancialRecurrence['generation'],
): { text: string; tone: 'positive' | 'info' } {
  const generated = generation?.generated ?? [];
  const pending = generation?.pending ?? [];
  const parts = [base];
  if (generated.length === 1)
    parts.push(`Despesa de ${monthName(generated[0]!)} lançada em Despesas.`);
  if (generated.length > 1)
    parts.push(
      `${generated.length} despesas lançadas em Despesas, de ${monthName(generated[0]!)} a ${monthName(generated.at(-1)!)}.`,
    );
  if (pending.length > 0)
    parts.push(
      `${capitalized(pending.map(monthName).join(', '))} ${pending.length === 1 ? 'ficou pendente' : 'ficaram pendentes'}: já existe lançamento parecido. Use Lançar mês para revisar.`,
    );
  return { text: parts.join(' '), tone: pending.length > 0 ? 'info' : 'positive' };
}
